
/* injects from baggage-loader */
require('./style.scss');

import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Hls from 'hls.js';
function VideoStreamPopup ({ providerId, url, gameId }) {
    const videoRef = useRef(null);
    useEffect(() => {
        let hls = null;
        if (Hls.isSupported() && url) {
            hls = new Hls();
            hls.loadSource(url);
            hls.attachMedia(videoRef.current);
            hls.on(Hls.Events.MANIFEST_PARSED, function () {
                videoRef.current.play();
            });
        } else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
            videoRef.current.src = url;
            videoRef.current.addEventListener('loadedmetadata', function () {
                videoRef.current.play();
            });
        }
        return () => {
            hls?.destroy?.();
        };
    }, [url]);
    if (parseInt(providerId) === 21 || parseInt(providerId) === '22' || parseInt(providerId) === '23' || parseInt(providerId) === '24') {
        return (
            <>
                <iframe src={url} width="100%" height="100%" frameBorder="0" scrolling="no" />
            </>
        );
    } return (
        <>
            <div className='preview-section' >
                <video ref={videoRef}/>
            </div>
        </>
    );
}
VideoStreamPopup.propTypes = {
    videoUrl: PropTypes.string
};
export default VideoStreamPopup;

// import React, { Component, Fragment } from 'react';
// // import { connect } from 'react-redux';
// import PropsType from 'prop-types';
// import Hls from "hls.js";
// import './style.scss';
// class VideoStreamPopup extends Component {
//     constructor (props) {
//         super(props);
//         this.videoRef = React.createRef();
//         const { providerId, url, gameId } = this.props;
//         this.state = {
//             SwfPleyerRerenderCount: 1,
//             providerId,
//             url,
//             gameId,
//             hls: null
//         };
//     }
//     componentDidMount () {
//         let hls = null;
//         const { url } = this.props;
//         if (url) {
//             if (Hls.isSupported()) {
//                 this.setState({ hls: new Hls() }, () =>
//                     this.state.hls.loadSource(url),
//                 this.state.hls.attachMedia(this.videoRef.current),
//                 this.state.hls.on(Hls.Events.MANIFEST_PARSED, function () {
//                     this.videoRef.current.play();
//                 }));
//             } else if (this.videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
//                 this.videoRef.current.src = url;
//                 this.videoRef.current.addEventListener('loadedmetadata', function () {
//                     this.videoRef.current.play();
//                 });
//             }
//             console.log(this.state, '=====STATE');
//         }
//     }
//     // componentDidUpdate () {
//     //     const { providerId, url, gameId } = this.props;
//     //     let hls = null;
//     //     if (Hls.isSupported()) {
//     //         hls = new Hls();
//     //         hls.loadSource(url);
//     //         console.log(this.videoRef, '=======');
//     //         hls.attachMedia(this.videoRef.current);
//     //         hls.on(Hls.Events.MANIFEST_PARSED, function () {
//     //             this.videoRef.current.play();
//     //         });
//     //     } else if (this.videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
//     //         this.videoRef.current.src = url;
//     //         this.videoRef.current.addEventListener('loadedmetadata', function () {
//     //             this.videoRef.current.play();
//     //         });
//     //     }
//     // }
//     // static getDerivedStateFromProps (nextProps, prevState) {
//     //     const { gameId, providerId, url } = nextProps;
//     //     let hls = null;
//     //     if (Hls.isSupported()) {
//     //         hls = new Hls();
//     //         hls.loadSource(url);
//     //         console.log(this.videoRef, '=======');
//     //         hls.attachMedia(this.videoRef.current);
//     //         hls.on(Hls.Events.MANIFEST_PARSED, function () {
//     //             this.videoRef.current.play();
//     //         });
//     //     } else if (this.videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
//     //         this.videoRef.current.src = url;
//     //         this.videoRef.current.addEventListener('loadedmetadata', function () {
//     //             this.videoRef.current.play();
//     //         });
//     //     }
//     //     if (gameId !== prevState.gameId) {
//     //         return ({
//     //             gameId,
//     //             SwfPleyerRerenderCount: prevState.SwfPleyerRerenderCount + 1,
//     //             providerId,
//     //             url
//     //         });
//     //     }
//     //     return null;
//     // }
//     componentDidCatch (error) {
//         console.error(error);
//     }
//     render () {
//         const { url, providerId } = this.state;
//         console.log(this.state);
//         if (parseInt(providerId) === 21 || parseInt(providerId) === '22' || parseInt(providerId) === '23' || parseInt(providerId) === '24') {
//             return (
//                 <Fragment>
//                     <iframe src={url} width="100%" height="100%" frameBorder="0" scrolling="no" />
//                 </Fragment>
//             );
//         } return (
//             <Fragment>
//                 <div className='preview-section' >
//                     <video ref={this.videoRef} autoPlay={true}/>
//                 </div>
//             </Fragment>
//         );
//     }
// }
// VideoStreamPopup.propsType = {
//     props: PropsType.objectOf(PropsType.any).isRequired
// };